<template>
    <v-dialog
        v-model="ProcessVerifierDialog"
        max-width="900px"
        hide-overlay
        persistent
        transition="dialog-bottom-transition"
    >
        <v-card
            elevation="2"
            outlined
            shaped
            style="padding: 40px;"
        >
            <div
                v-if="DvrEleosApp == 1"
            >
                <div
                    style="display: grid;grid-template-columns: 8fr 1fr;margin: 30px 0;align-items: center;"
                >
                    <div v-if="EmailCounterReference == 0">
                        <p style="margin: 0;font-size: x-large;">Orders ready on the tablet</p>
                    </div>
                    <div v-else>
                        <p style="margin: 0;font-size: x-large;">Updates ready on the tablet</p>
                    </div>
                    <div>
                        <div v-if="LoadsReady === 'loading'">
                            <div class="sk-chase">
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                            </div>
                        </div>
                        <div v-else-if="LoadsReady === 'success'">
                            <v-icon
                                large
                                color="green darken-2"
                            >
                                mdi-check-circle
                            </v-icon>
                        </div>
                        <div v-else-if="LoadsReady === 'error'">
                            <v-icon
                                large
                                color="red darken-2"
                            >
                                mdi-close-circle
                            </v-icon>
                        </div>
                    </div>
                </div>
                <v-divider></v-divider>
                <div
                    style="display: grid;grid-template-columns: 8fr 1fr;margin: 30px 0;align-items: center;"
                >
                    <p style="margin: 0;font-size: x-large;">Driver notified in the app</p>
                    <div>
                        <div v-if="LoadsReady === 'loading'">
                            <div class="sk-chase">
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                            </div>
                        </div>
                        <div v-else-if="LoadsReady === 'success'">
                            <v-icon
                                large
                                color="green darken-2"
                            >
                                mdi-check-circle
                            </v-icon>
                        </div>
                        <div v-else-if="LoadsReady === 'error'">
                            <v-icon
                                large
                                color="red darken-2"
                            >
                                mdi-close-circle
                            </v-icon>
                        </div>
                    </div>
                </div>
                <v-divider></v-divider>
                <div
                    style="display: grid;grid-template-columns: 8fr 1fr;margin: 30px 0;align-items: center;"
                >
                    <p style="margin: 0;font-size: x-large;">Mail sent to the driver</p>
                    <div>
                        <div v-if="MailingReady === 'loading'">
                            <div class="sk-chase">
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                            </div>
                        </div>
                        <div v-else-if="MailingReady === 'success'">
                            <v-icon
                                large
                                color="green darken-2"
                            >
                                mdi-check-circle
                            </v-icon>
                        </div>
                        <div v-else-if="MailingReady === 'error'">
                            <v-icon
                                large
                                color="red darken-2"
                            >
                                mdi-close-circle
                            </v-icon>
                        </div>
                    </div>
                </div>
            </div> <!-- if Eleos -->
            <div
                v-else
            >
                <v-divider></v-divider>
                <div
                    style="display: grid;grid-template-columns: 8fr 1fr;margin: 30px 0;align-items: center;"
                >
                    <div>
                        <p 
                            style="margin: 0;font-size: x-large;"
                        >
                            Mail sent to the driver
                        </p>
                    </div>
                    <div>
                        <div v-if="MailingReady === 'loading'">
                            <div class="sk-chase">
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                                <div class="sk-chase-dot"></div>
                            </div>
                        </div>
                        <div v-else-if="MailingReady === 'success'">
                            <v-icon
                                large
                                color="green darken-2"
                            >
                                mdi-check-circle
                            </v-icon>
                        </div>
                        <div v-else-if="MailingReady === 'error'">
                            <v-icon
                                large
                                color="red darken-2"
                            >
                                mdi-close-circle
                            </v-icon>
                        </div>
                    </div>
                </div>
                <v-divider></v-divider>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
    // Imports here

    export default {
        props: ['MailingReady', 'LoadsReady', 'EmailCounterReference', 'DvrEleosApp','shiftSummaryDialog', 'ProcessVerifierDialog'],
        components: {
        },
        data: function() {
            return {
                //variables: [],
                //here: true,
                //...
            }
        },
        mounted() {
            //this.functionsForMountedHere();
        },
        methods: {
            /*functionHere: function() {

            },
            otherFunctionHere: function() {

            }
            */
        },
    };
</script>

<style>
    .sk-chase {
        width: 40px;
        height: 40px;
        position: relative;
        animation: sk-chase 2.5s infinite linear both;
    }

    .sk-chase-dot {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0; 
        animation: sk-chase-dot 2.0s infinite ease-in-out both; 
    }

    .sk-chase-dot:before {
        content: '';
        display: block;
        width: 25%;
        height: 25%;
        background-color: #fff;
        border-radius: 100%;
        animation: sk-chase-dot-before 2.0s infinite ease-in-out both; 
    }

    .sk-chase-dot:nth-child(1) { animation-delay: -1.1s; }
    .sk-chase-dot:nth-child(2) { animation-delay: -1.0s; }
    .sk-chase-dot:nth-child(3) { animation-delay: -0.9s; }
    .sk-chase-dot:nth-child(4) { animation-delay: -0.8s; }
    .sk-chase-dot:nth-child(5) { animation-delay: -0.7s; }
    .sk-chase-dot:nth-child(6) { animation-delay: -0.6s; }
    .sk-chase-dot:nth-child(1):before { animation-delay: -1.1s; }
    .sk-chase-dot:nth-child(2):before { animation-delay: -1.0s; }
    .sk-chase-dot:nth-child(3):before { animation-delay: -0.9s; }
    .sk-chase-dot:nth-child(4):before { animation-delay: -0.8s; }
    .sk-chase-dot:nth-child(5):before { animation-delay: -0.7s; }
    .sk-chase-dot:nth-child(6):before { animation-delay: -0.6s; }

    @keyframes sk-chase {
        100% { transform: rotate(360deg); } 
    }

    @keyframes sk-chase-dot {
        80%, 100% { transform: rotate(360deg); } 
    }

    @keyframes sk-chase-dot-before {
        50% {
            transform: scale(0.4); 
        } 100%, 0% {
            transform: scale(1.0); 
        } 
    }
</style>